import {useEffect, useState} from 'react';
import { Loading } from './';
import {
  Card,
  CardBody,
  Col,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  InputGroup,
  InputGroupText,
  CardHeader,
  ButtonGroup,
  UncontrolledTooltip
} from 'reactstrap';
import { api, constants, ui_helpers } from "../helpers";
import _ from "lodash";
import Alert from "react-s-alert-v3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ToggleButton from "react-toggle-button";
import Select from "react-select";

const DEFAULT_CONTEXT = {value: constants.DEFAULT_PRICING_CONTEXT, label: "(Default - Not manufacturer specific)"};
const tabNames =  constants.PRODUCT_TYPE_IDS;
const DEFAULT_TERM_SETTINGS = {
    companyId: null,
    productType: null,
    contractTerm: null,
    paymentDenominator: 0,
    payOffPercent: 0,
    minimumSecurityDeposit: 0,
    minimumUnitPrice: 0,
    maximumUnitPrice: 0,
    securityDepositPercentage: 0,
    purchaseReserveThresholdPercent: 0,
    additionalSecurityDepositPercentage: 0,
    fourteenFtWideAdditionalSecurityDeposit: 0,
    sixteenFtWideAdditionalSecurityDeposit: 0,
    initialPaymentRequired: false,
    isActive: false,
}

const ContractTermDetails = ({companyId, manufacturerId, type, term, ctDetails, onRefreshTerms}) => {
  const [companyTerm, setCompanyTerm] = useState(ctDetails);
  const [saving, setSaving] = useState(false);

  function resolveContext(override) {
    let result = override ? override : {...companyTerm};
    if (!result.companyId)
      result.companyId = companyId;
    if (!result.productType && type)
      result.productTypeId = type.value;
    if (!result.productTypeId && result.productType) {
      result.productTypeId = result.productType.value;
      delete result.productType;
    }
    if (!result.contractTerm && term)
      result.contractTermId = term.value;
    if (!result.contractTermId && result.contractTerm) {
      result.contractTermId = result.contractTerm.value;
      delete result.contractTerm;
    }
    result.manufacturerId = manufacturerId;
    return result;
  }

  const onSave = (cTerm) => {
    const payload = resolveContext(cTerm);
    if (saving) 
      return;
    if (!payload.companyId || !payload.productTypeId || !payload.contractTermId)
      return;
    setSaving(true);
    api.post("Company/SaveCompanyTerm", payload)
      .then(completeSaveOperation)
      .catch(api.catchHandler)
      .finally(() => setSaving(false));
  }

  const onClone = (cTerm) => {
    const payload = resolveContext(cTerm);
    if (saving) 
      return;
    if (!payload.companyId || !payload.productTypeId || !payload.contractTermId)
      return;
    setSaving(true);
    api.post("Company/CloneCompanyTerm", payload)
      .then(completeSaveOperation)
      .catch(api.catchHandler)
      .finally(() => setSaving(false));
  }

  function completeSaveOperation(res) {
    if (res.data && res.data.success) {
      if (res.data.message) {
        setCompanyTerm({
          ...companyTerm, 
          id: res.data.message.id, 
          isActive: res.data.message.isActive
        });
        onRefreshTerms();
        Alert.success("Saved Successfully");
      } else {
        Alert.warning("No default, source company term exists to clone.");
      }
    } else {
      Alert.error(res.data.message || "An error occurred. Term cannot be saved at this time.")
    }
  }

  function onToggleChange(value){
    let cTerm = Object.assign({}, companyTerm);
    cTerm.isActive = value;
    setCompanyTerm(cTerm);
    if (companyTerm.id > 0) {
      onSave(cTerm);
    }
  }

  return (<>
        {type && term && ctDetails &&
            <Card key={`type-${type}-term-${term.value}`} className="p-2">
                <CardHeader>
                    <Row>
                        <Col>
                          <ToggleButton 
                            inactiveLabel={<FontAwesomeIcon icon="times-circle" color="danger"/>}
                            activeLabel={<FontAwesomeIcon icon="check-circle" color="success"/>}
                            value={companyTerm.isActive}
                            onToggle={(value) => onToggleChange(!value)}
                          />
                        </Col>
                        <Col className="text-center"><h5>{term.label}</h5></Col>
                        <Col className="float-end">{
                            <ButtonGroup className="float-end">
                              {companyTerm.collapse && manufacturerId && manufacturerId !== constants.DEFAULT_PRICING_CONTEXT
                                ? (<FontAwesomeIcon className="text-info cursor me-2" onClick={() => onClone()} icon="clone" size="2x" title="Clone from default" spin={saving} />)
                                : null
                              }
                              {companyTerm.collapse 
                                ? (<FontAwesomeIcon className="text-blue cursor me-2" onClick={() => onSave()} icon="save" size="2x" title="Save" spin={saving} />)
                                : null}
                              <FontAwesomeIcon 
                                title={`Click to ${companyTerm.collapse ? "Hide" : "Expand"}`}
                                onClick={() => setCompanyTerm({...companyTerm, collapse: !companyTerm.collapse})} 
                                icon={companyTerm.collapse ? "chevron-circle-up" : "chevron-circle-down"} size="2x" className="float-end text-dark cursor ml-2"
                              />
                            </ButtonGroup> 
                            }
                        </Col>
                    </Row>
                </CardHeader>
                {companyTerm.collapse 
                  ? (<CardBody>
                      <Row>
                        <Col md='12'>
                          <InputGroup className="pricingCenter">
                              <InputGroupText>
                              <div>
                                  <Row>
                                      <Col>
                                          <InputGroupText>
                                              <span>
                                                  The Payment Divisor is {" "}
                                                  <input size="10" maxlenght="10" className="text-center ml-2 mr-2" value={companyTerm.paymentDenominator} onChange={(e)=>setCompanyTerm({...companyTerm, paymentDenominator: e.target.value})} />,
                                                  and the EPO % of Contract Balance is {" "}
                                                  <input size="10" maxlenght="10" className="text-center  ml-2 mr-2" value={companyTerm.payOffPercent} onChange={(e)=>setCompanyTerm({...companyTerm, payOffPercent: e.target.value})} />
                                                  <b>%</b>
                                              </span>
                                          </InputGroupText>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
                                          <InputGroupText>
                                              <span className="mr-2 ml-2">The standard deposit required to open a contract is {" "}
                                                  <input size="10" maxlength="10" className="text-center" value={companyTerm.securityDepositPercentage} onChange={(e)=>setCompanyTerm({...companyTerm, securityDepositPercentage: e.target.value})} />
                                                  <b>%</b>, of unit cash price. 
                                              </span>
                                          </InputGroupText>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
                                          <InputGroupText>
                                              <span className="mr-2">
                                                  <Row>
                                                      <Col>
                                                          <ToggleButton 
                                                              inactiveLabel={"No"}
                                                              activeLabel={"Yes"}
                                                              value={companyTerm.initialPaymentRequired}
                                                              checked={companyTerm.initialPaymentRequired}
                                                              onToggle={(value) => {
                                                                  setCompanyTerm({...companyTerm,
                                                                      initialPaymentRequired: !value,
                                                                  })
                                                              }}
                                                              colors={{
                                                                  inactive: {
                                                                  base: 'rgb(207,221,245)',
                                                                  hover: 'rgb(177, 191, 215)',
                                                                  },
                                                                  active: {
                                                                  base: 'rgb(1,124,66)', 
                                                                  hover: 'rgb(24,94,32)'
                                                                  }
                                                              }}
                                                          />
                                                      </Col>
                                                      <Col><span>initial payment is required to open a contract.</span></Col>
                                                  </Row>
                                              </span>
                                          </InputGroupText>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
                                          <InputGroupText>
                                              <span>
                                                  This term is available to a minimum security deposit price of <b>$</b> 
                                                  <input size="18" maxlenght="18" className="text-center" value={companyTerm.minimumSecurityDeposit} onChange={(e)=>setCompanyTerm({...companyTerm, minimumSecurityDeposit: e.target.value})} /> 
                                              </span>
                                          </InputGroupText>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
                                          <InputGroupText>
                                              <span>
                                                  <b>$</b><input size="18" maxlenght="18"  className="text-center" value={companyTerm.fourteenFtWideAdditionalSecurityDeposit} onChange={(e)=>setCompanyTerm({...companyTerm, fourteenFtWideAdditionalSecurityDeposit: e.target.value})} /> 
                                                  additional deposit is required on all 14' wide units. 
                                              </span>
                                          </InputGroupText>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
                                          <InputGroupText>
                                              <span>
                                                  <b>$</b><input size="18" maxlenght="18" className="text-center" value={companyTerm.sixteenFtWideAdditionalSecurityDeposit} onChange={(e)=>setCompanyTerm({...companyTerm, sixteenFtWideAdditionalSecurityDeposit: e.target.value})} /> 
                                                  additional deposit is required on all 16' wide units. 
                                              </span>
                                          </InputGroupText>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
                                          <InputGroupText>
                                              <span>
                                                  Add purchase reserve to the contract when the down payment exceeds 
                                                  <input size="10" maxlenght="10" className="text-center" value={companyTerm.purchaseReserveThresholdPercent} onChange={(e)=>setCompanyTerm({...companyTerm, purchaseReserveThresholdPercent: e.target.value})} /> 
                                                  <span><b>%</b> of unit cash price.</span>
                                              </span>
                                          </InputGroupText>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
                                          <InputGroupText>
                                              <span>
                                                  This term is available to a minimum unit cash price of <b>$</b> 
                                                  <input size="18" maxlenght="18" className="text-center" value={companyTerm.minimumUnitPrice} onChange={(e)=>setCompanyTerm({...companyTerm, minimumUnitPrice: e.target.value})} /> 
                                                  <span> and a maximum of <b>$</b></span>
                                                  <input size="18" maxlenght="18" className="text-center" value={companyTerm.maximumUnitPrice} onChange={(e)=>setCompanyTerm({...companyTerm, maximumUnitPrice: e.target.value})} /> 
                                              </span>
                                          </InputGroupText>
                                      </Col>
                                  </Row>
                                  <Row>
                                      <Col>
                                          <InputGroupText>
                                              <span>
                                                  Apply 
                                              </span>
                                              <input size="10" maxlenght="10" className="text-center" value={companyTerm.additionalSecurityDepositPercentage} onChange={(e)=>setCompanyTerm({...companyTerm, additionalSecurityDepositPercentage: e.target.value})} /> 
                                              <span className="mr-2 ml-2"><b>%</b> of threshold overage to down payment requirement when unit cash price exceeds maximum.</span>
                                              <span className="mr-2 ml-2">
                                                  <FontAwesomeIcon icon="info" id="info" />
                                                  <UncontrolledTooltip target="info">To disallow contracts over the maximum unit cash price entirely, leave this field empty.</UncontrolledTooltip>
                                              </span>
                                          </InputGroupText>
                                      </Col>
                                  </Row>
                                  </div>
                              </InputGroupText>
                          </InputGroup>
                        </Col>
                      </Row>
                    </CardBody>) 
                  : null
                }
            </Card>
        }
        </>
    );
};

export default function CompanyPricing(props){
  const [company, setCompany] = useState(props.company);
  const [productTypes, setProductTypes] = useState([]);
  const [activeTab, setActiveTab] = useState(tabNames.STORAGE_BUILDING);
  const [loading, setLoading] = useState(false);
  const [companyTerms, setCompanyTerms] = useState([]);
  const [contractTerms, setContractTerms] = useState(
    _.reject(Object.assign([], constants.CONTRACT_TERMS), t => t.value === constants.CONTRACT_TERM_TYPES.OTHER.value)
  );
  const [companyManufacturerList, setCompanyManufacturerList] = useState([]);
  const [manufacturer, setManufacturer] = useState(DEFAULT_CONTEXT);

  useEffect(() => {
    let types = _.reject(constants.PRODUCT_TYPES, t => t.value < 0);
    types.push(constants.OTHER_OPTION);
    setProductTypes(types);
    api.fetch(`Company/CompanyManufacturerList/${company.id}`).then(res => {
      let mfgList = [];
      if (res.data && res.data.data) {
        // a company can hold more than one active relation row per manufacturer, and the
        // manufacturer table itself can carry more than one record under the same name;
        // this dropdown only cares about distinct, distinguishable manufacturers
        mfgList = _.chain(res.data.data)
          .map((m) => ({value: m.manufacturerId, label: (m.manufacturerName || "").trim()}))
          .uniqBy("value")
          .uniqBy((m) => m.label.toLowerCase())
          .sortBy((m) => m.label.toLowerCase())
          .value();
      }
      mfgList.unshift(DEFAULT_CONTEXT);
      setCompanyManufacturerList(mfgList);
    }).catch(api.catchHandler);
  }, []);

  useEffect(() => {
    if (!company || !company.id|| !productTypes || !productTypes.length) return;
    getCompanyTerms();
  }, [productTypes, manufacturer]);

  function getCompanyTerms() {
    const mfgId = manufacturer
      ? manufacturer.value
      : constants.DEFAULT_PRICING_CONTEXT;
    setLoading(true);
    api.fetch(`Company/GetCompanyTermList/${company.id}/${mfgId}`).then(res => {
      if (res.data && res.data.success) {
        if (res.data.message && res.data.message.length) {
          const terms = _.map(res.data.message, d => {
            d.contractTerm = ui_helpers.mapIdNameToValueLabel(d.contractTermId, d.contractTermName);
            d.productType = ui_helpers.mapIdNameToValueLabel(d.productTypeId, d.productTypeName);
            d.payOffPercent = (d.payoffPercent * 100).toFixed(2);
            d.purchaseReserveThresholdPercent = (d.purchaseReserveThresholdPercent * 100);
            d.securityDepositPercentage = (d.securityDepositPercentage * 100);
            d.additionalSecurityDepositPercentage = (d.additionalSecurityDepositPercentage * 100);
            return d;
          });
          setCompanyTerms(resolveCompanyTerms(terms));
        } else { //initialize contractTerms
          setCompanyTerms(resolveCompanyTerms([]));
        }
      }
    }).finally(() => setLoading(false));
  }

  function saveMaxInitialPaymentPercentage() {
    let tmp = parseFloat(company.maxInitialPaymentPercent);
    if (!tmp || tmp < 0.0) {
      tmp = null;
    } else if (tmp < 1.0) {
      tmp = tmp * 100.0;
    }
    api.post("Company/SaveCompanyPricingHeader", {
      companyId: company.id,
      maxInitialPaymentPercent: tmp.toFixed(2)
    }).then(res => {
      if (!res.data.success) {
        Alert.error("Failed to save the new maximum initial payment percentage.");
      }
    });
  }

  function resolveCompanyTerms(termList){
    let list = [];
    contractTerms.slice().forEach(term => {
      productTypes.slice().forEach(type => {
        let ex = _.find(termList, t => t.productType.value === type.value && t.contractTerm.value === term.value);
        if (!ex) {
          ex = Object.assign({}, DEFAULT_TERM_SETTINGS);
          ex.companyId = company.id;
          ex.productType = type;
          ex.contractTerm = term;
          ex.collapse = false;
        }
        list.push(ex);
      });
    });
    return list;
  }

  return (<>
    {company ? (
      <Card>
        <CardHeader>
          <h2 className="page-title">
            {company.name} {!props.isCaptiveCompany ? "RTO" : null} Pricing
          </h2>
        </CardHeader>
        <CardBody>
          {!props.isCaptiveCompany ?
            <>
              <Row className="mb-2">
                <Col xs="2" className="pt-2">
                  Maximum Initial Down Payment %
                </Col>
                <Col xs="1">
                  <input
                    maxLength="10"
                    className="text-center form-control"
                    value={company.maxInitialPaymentPercent}
                    onChange={(e) => setCompany({...company, maxInitialPaymentPercent: e.target.value})}
                    onBlur={saveMaxInitialPaymentPercentage}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="2" className="pt-2">
                  <span>Manufacturer Context</span>
                </Col>
                <Col xs="4">
                  <Select
                    options={companyManufacturerList}
                    onChange={setManufacturer}
                    value={manufacturer}
                  />
                </Col>
              </Row>
              <Nav tabs className="mt-2">
                  {productTypes.length 
                      ? productTypes.map(type =>(
                      <NavItem >
                          <NavLink
                            className={` ${activeTab === type.value ? "active" : ""}`}
                            onClick={() => setActiveTab(type.value)}
                          >
                            {type.label}
                          </NavLink>
                      </NavItem>
                  )) : null}
              </Nav>
              <TabContent activeTab={activeTab} className="mt-2">
              {loading
                ? (<Loading />)
                : null
              }
              {!loading && productTypes.length 
                  ? _.map(productTypes, (pt, index) => (
                      pt.value === activeTab 
                      ? (<TabPane tabId={pt.value} key={`type=${pt.value}-${manufacturer?.value}-${index}`}>
                          {contractTerms.length
                            ? _.map(contractTerms, (term, idx) => (
                                _.chain(companyTerms)
                                .filter(ct => ct.contractTerm.value === term.value && pt.value === ct.productType.value)
                                .map(ct => (
                                  <ContractTermDetails 
                                    key={`t-${manufacturer?.value}-${term.value}`} 
                                    companyId={company.id}
                                    type={pt} 
                                    term={term}
                                    manufacturerId={manufacturer?.value}
                                    ctDetails={ct} 
                                    onRefreshTerms={getCompanyTerms} 
                                  />))
                                .value()
                              ))
                            : null
                          }
                        </TabPane>)
                      : null                      
                  )) : null}
              </TabContent>
            </>
            : (<Row className="center"><Col><b>Pricing Rules are only available to RTO Companies</b></Col></Row>)}
        </CardBody>
      </Card>
    ) : null}
  </>);
}

